  <div class="dashboard">
	<div *ngIf="dashboard.ui_fragments_decoded && dashboard.ui_fragments_decoded.WELCOME_markup"
		class="dashboard-welcome-copy">
	  		<span [innerHTML]="dashboard.ui_fragments_decoded.WELCOME_markup | safeHtml"></span>
	</div>  
  </div>
  <div class="dashboard tiles-row">
	<div *ngFor="let block of dashboard.contentBlocks; let i = index;" class="tile">
      <div class="panel panel-body contentblock yScrollOnly">
        <div class="row text-center">
          <div class="col-xs-12" [ngClass]="{pointMe : block.action != 'button' || block.link }"
               (click)="dashboardBlockClick(block)" style="height:200px;">
            <img *ngIf="block.thumbnail" 
            	[src]="block.thumbnail" 
            	alt="{{block.thumbnailAlt || ''}}"
                class="img-thumbnail" 
                style="padding:0px;height:100%" />
          </div>
          <div>
            <h3 [ngClass]="{pointMe : block.action != 'button'}"
                (click)="(block.action.toLowerCase() == 'button') || dashboardBlockClick(block)">
                	{{block.label}}
            </h3>
				<p [innerHTML]="block.description | safeHtml"></p>
          </div>
          <div>
            <button *ngIf="block.search && block.action.toLowerCase() == 'button'" class="btn btn-md btn-default"
                    (click)="dashboardSearch(block)">{{LOCALIZATION.search}}</button>
            <button *ngIf="block.browse && block.action.toLowerCase() == 'button'" class="btn btn-md btn-default"
                    (click)="dashboardBrowse(block)">{{LOCALIZATION.browse}}</button>
          </div>
        </div>
        <div *ngIf="block.results && block.results.length>0" class="row dashboard-results">
          <div *ngFor="let result of block.results.slice(block.blockIndex,block.blockIndex+3)" class="dashboard-result"
               (click)="openDashboardResult(block.results, result.id)">
            <div *ngIf="!result.thumbnail">
              <a class="dashboard-link">
                {{result._title}}
              </a>
            </div>
            <div *ngIf="result.thumbnail">
              <img [src]="result.thumbnail" class="dashboard-thumbnail" />
            </div>
          </div>
        </div>
        <!-- TODO: replace this implementation -->
        <div *ngIf="block.results && block.results.length>0" class="row">
          <div class="left arrow leftArrow" (click)="scrollDashboard(i, true)" *ngIf="block.blockIndex>0"></div>
          <div class="right arrow rightArrow" (click)="scrollDashboard(i, false)" *ngIf="block.blockIndex+3<block.results.length"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="dashboard">
	<span class="dashboard-footer-copy"></span>  
  </div>
  